import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  settingsContent: {
    paddingBottom: Theme.px(59),
  },
  settingsWrapper: {
    paddingTop: Theme.px(311),
  },
});
